// extracted by mini-css-extract-plugin
export default {"overrides":"dialog-box_overrides__yo2m8","title":"dialog-box_title__CaaBN","subtitle":"dialog-box_subtitle__DZy3H","content":"dialog-box_content__eTooG"};